export default __webpack_public_path__ + "static/pokitpal-8b3dcf29e6abb34fd0fe1a8e46e7d999.png";